<template>
  <section class="section hero-section-container">
    <div class="hero-content-wrapper">
      <div class="hero-content">
        <h1 class="hero-title">Join the Teamstack Roster</h1>
        <p class="hero-description">
          At TeamStack, we aim to connect exceptional talent with progressive companies across Europe, Asia, and North America wanting to build remote technical teams. We are, to this end, building a curated roster of professionals in engineering, design, and product management at all experience levels. If you're looking for meaningful remote opportunities with forward-thinking organizations, consider joining the roster!
        </p>
      </div>
      <div class="hero-image-container">
         <img src="@/assets/images/hero-image.png" alt="Hero Section Image" class="hero-image-placeholder" />
      </div>
    </div>
  </section>
</template>

<style scoped>
.hero-section-container {
  max-width: unset;
  margin: 0;
  padding-top: 0;
  background-color: #FEF6EB;
  min-height: 680px;

  position: relative;
  overflow: hidden;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: -72px;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('@/assets/images/noise-bg-hero.png');
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100%;
    z-index: 0;
  }

  .hero-content-wrapper {
    max-width: 1120px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    justify-items: center;
    align-items: center;
    gap: 40px;

    @media screen and (max-width: 1120px) {
      margin: 0 16px;
    }

    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr;
    }
  }

  .hero-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .hero-image-container {
    display: flex;
    margin: 0 auto;
  }

  .hero-image-placeholder {
    width: 320px;

    @media screen and (max-width: 768px) {
      width: auto;
      height: 400px;
    }
  }

  .hero-title {
    font-size: 3.75rem;
    font-weight: 700;
    color: #141414;
    line-height: 1.25;
  }

  .hero-description {
    font-size: 1.25rem;
    color: #141414;
    line-height: 1.6;
  }
}

@media screen and (max-width: 1120px) {
  .hero-title {
    font-size: 2.5rem;
  }
}

@media screen and (max-width: 768px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-description {
    font-size: 1.125rem;
  }
}
</style>